import { PageHeader } from '@app/components/layout/page/components/page-header';
import Page from '@app/components/layout/page/page';
import Text from '@shared/components/content/text';
import { generatePath } from 'react-router-dom';
import { soldGoodsRoutes } from '../../sold-goods-routes';
import ExcludedSoldItemsToolbar from '../components/excluded-sold-items-toolbar';
import ExcludedSoldItemsTab from '../excluded-sold-items-tab';
import {
  excludedItemsConfig,
  excludedItemsHref,
  ExcludedItemType,
} from '../tabs';

interface ExcludedSoldItemsCategoryPageProps {
  type: ExcludedItemType;
}

/**
 * Standalone subpage for one sold-goods excluded-items category, reached from
 * the Excluded items landing cards (e.g. Sold goods › Excluded items › Other
 * goods). Renders the shared filter toolbar plus the category's listing.
 */
export default function ExcludedSoldItemsCategoryPage({
  type,
}: ExcludedSoldItemsCategoryPageProps) {
  const { title, description } = excludedItemsConfig[type];

  return (
    <Page name={title} title={title}>
      <PageHeader
        name={title}
        breadcrumbs={[
          {
            label: 'Sold goods',
            url: generatePath(soldGoodsRoutes.SOLD_FOOD_AND_DRINK),
          },
          {
            label: 'Excluded items',
            url: generatePath(soldGoodsRoutes.SOLD_EXCLUDED_ITEMS),
          },
          {
            label: title,
            url: generatePath(excludedItemsHref(type)),
          },
        ]}
      />
      <Text variant="subtle" className="-mt-2 mb-4 max-w-2xl">
        {description}
      </Text>
      {/* Match the toolbar→table gap DataTable uses internally (gap-2.5),
          since the toolbar lives outside the listing's DataTable. */}
      <div className="flex flex-col gap-2.5">
        <ExcludedSoldItemsToolbar />
        <ExcludedSoldItemsTab type={type} />
      </div>
    </Page>
  );
}
